import React, { FC } from 'react'

import { EventRow } from 'widgets/event-row'
import { useAppFeatureFlag } from 'shared/config'

import { EventRowProps } from './EventRow.types'

export const EventRowHoc: FC<EventRowProps> = ({
  event,
  page1EventIds,
  page2EventIds,
  inactivePagesEventIds,
  outcomesFetchType
}) => {
  const shouldRenderMarkers = useAppFeatureFlag(
    'RENDER_EVENT_LIST_PAGES_MARKERS'
  )
  const eventId = event.id

  let isOverview = false
  let comp: JSX.Element = <div />
  let position: 'before' | 'after' = 'before'

  if (shouldRenderMarkers) {
    if (inactivePagesEventIds.length !== 0) {
      if (eventId === inactivePagesEventIds[0]) {
        comp = <div style={{ border: '1px black solid' }} />
        position = 'before'
      } else if (
        eventId === inactivePagesEventIds[inactivePagesEventIds.length - 1]
      ) {
        comp = <div style={{ border: '1px black solid' }} />
        position = 'after'
      }
    }
    if (page1EventIds.length !== 0) {
      if (eventId === page1EventIds[0]) {
        comp = <div style={{ border: '1px red solid' }} />
        position = 'before'
      } else if (eventId === page1EventIds[page1EventIds.length - 1]) {
        comp = <div style={{ border: '1px red solid' }} />
        position = 'after'
      }
    }

    if (page2EventIds.length !== 0) {
      if (eventId === page2EventIds[0]) {
        comp = <div style={{ border: '1px blue solid' }} />
        position = 'before'
      } else if (eventId === page2EventIds[page2EventIds.length - 1]) {
        comp = <div style={{ border: '1px blue solid' }} />
        position = 'after'
      }
    }
    const isFirstPage = page1EventIds.includes(eventId)
    const isSecondPage = page2EventIds.includes(eventId)
    isOverview = !isFirstPage && !isSecondPage
  }

  return (
    <>
      {position === 'before' && comp}
      <EventRow
        event={event}
        isOverview={isOverview}
        outcomesFetchType={outcomesFetchType}
      />
      {position === 'after' && comp}
    </>
  )
}
